import type {Colors} from '@travel-frontend/themes';

import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Title = styled.div<{textColor?: keyof Colors}>(
  ({theme, textColor = 'contentInversePrimary'}) => css`
    font: 700 1.25rem / 1.5rem ${theme.fontFamily};
    color: ${theme.colors[textColor]};

    ${theme.respondTo(
      'lg',
      css`
        font-size: 1.5rem;
        line-height: 1.875rem;
      `
    )}
  `
);
